import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordStrengthValidatorDirective } from './passwordstrength-validator.directive';

@NgModule({
    declarations: [PasswordStrengthValidatorDirective],
    imports: [CommonModule],
    exports: [PasswordStrengthValidatorDirective],
})
export class FiPasswordChangeModule {}
